// Tiny module-scoped store so the ConnectionAuthDrawer can be opened
// from anywhere (settings page, Den hero CTA, suggested actions) without
// prop-drilling. One drawer instance is mounted at app-shell level; any
// caller invokes openConnectionDrawer(platformKey?) and the drawer wakes
// up scrolled to that row.
//
// We deliberately don't use Zustand or Redux here — the surface is too
// small to justify an extra dep, and useSyncExternalStore gives us a
// React-blessed subscription with the right concurrent-rendering
// semantics out of the box.

import { useSyncExternalStore } from "react";

export interface DrawerState {
  open: boolean;
  defaultExpanded: string | null; // platform key to scroll-into-view + visually highlight
  context: "settings" | "den" | "suggested-action" | null;
}

let state: DrawerState = { open: false, defaultExpanded: null, context: null };
const listeners = new Set<() => void>();

function emit() {
  for (const fn of listeners) fn();
}

export function openConnectionDrawer(opts?: {
  platformKey?: string;
  context?: DrawerState["context"];
}): void {
  state = {
    open: true,
    defaultExpanded: opts?.platformKey ?? null,
    context: opts?.context ?? null,
  };
  emit();
}

export function closeConnectionDrawer(): void {
  state = { open: false, defaultExpanded: null, context: null };
  emit();
}

export function useConnectionDrawer(): DrawerState {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => state,
    () => state,
  );
}
